<template>
  <div class="add headFixed">
    <div class="head">
      <router-link to="/equipment"><img class="headImg" src="../../../assets/images/fanhui.png"></router-link>
      <span class="headTitle">定时设置</span>
    </div>
    <div class="dPo"></div>
    <div class="list list_normal list_no_arrow">
      <div class="item">
        <div class="clear">
          <p v-show="this.lucky==0">使用定时 <span class="right timerSwitch tTimer">
<!--            <mt-switch v-model="value"-->
            <!--                       @change="turn()"></mt-switch>-->
          </span>
          </p>
          <p v-show="this.lucky==1">使用定时 <span class="right timerSwitch tTimer">
<!--            <mt-switch v-model="closeVal"-->
            <!--                       @change="turnClose"></mt-switch>-->
          </span>
            <p v-show="this.lucky==2">使用定时 <span class="right timerSwitch tTimer">
<!--            <mt-switch v-model="value"-->
              <!--                       @change="turn()"></mt-switch>-->
          </span>
            </p>
          </p>
        </div>
      </div>
    </div>
    <ul class="nav clear container timerBox">
      <li :class="this.lucky==0?'active':''" @click="changelucky(0)">开机</li>
      <li :class="this.lucky==1?'active':''" @click="changelucky(1)">关机</li>
      <li :class="this.lucky==2?'active':''" v-if="this.$route.params.type==='air'" @click="changelucky(2)">定时温度</li>
      <router-link :to="'/equipment/timer/add/'+this.getId()+'/1'">
        <li class="addTimer" :class="this.lucky==0?'':'hide'">添加定时</li>
      </router-link>
      <router-link :to="'/equipment/timer/add/'+this.getId()+'/2'">
        <li class="addTimer" :class="this.lucky==1?'':'hide'">添加定时</li>
      </router-link>
      <router-link :to="'/equipment/timer/add/'+this.getId()+'/3'">
        <li class="addTimer" :class="this.lucky==2?'':'hide'">添加定时</li>
      </router-link>
    </ul>

    <div class="luckyItem timer container open" :class="this.lucky===0?'':'hide'">
      <div class="list" v-for="(item,index) in open" :key="index">
        <p class="clear">
          {{ item.time }}
          <span class="right timerSwitch">
            <span class="delTimer" @click="delTimer(item.id,index)">删除</span>
            <mt-switch :value="item.isOpen===1"
                       @change="changOpenVal(item.id,index,item.isOpen)"></mt-switch>
            </span>
        </p>
        <p class="time">
          <span>{{ item.date }}</span>
        </p>
        <!--       <p class="rooms">-->
        <!--          楼下主卧、楼上次卧、通道a的灯关闭-->
        <!--        </p>-->
      </div>
    </div>
    <div class="luckyItem timer container close" :class="this.lucky===1?'':'hide'">
      <div class="list" v-for="(item,index) in close" :key="index">
        <p class="clear">
          {{ item.time }}
          <span class="right timerSwitch">
            <span class="delTimer" @click="delTimer(item.id)">删除</span>
            <mt-switch :value="item.isOpen==1?true:false"
                       @change="changOpenVal(item.id,index,item.isOpen)"></mt-switch></span>
        </p>
        <p class="time">
          <span>{{ item.date }}</span>
        </p>
      </div>
    </div>
    <div class="luckyItem timer container close" :class="this.lucky===2?'':'hide'">
      <div class="list" v-for="(item,index) in temp" :key="index">
        <p class="clear">
          {{ item.time }} 绑定模式:{{item.mode === 1?"制热":"制冷"}} {{item.temperature}}°C
          <span class="right timerSwitch">
            <span class="delTimer" @click="delTimer(item.id)">删除</span>
            <mt-switch :value="item.isOpen==1?true:false"
                       @change="changOpenVal(item.id,index,item.isOpen)"></mt-switch></span>
        </p>
        <p class="time">
          <span>{{ item.date }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import {Toast} from 'mint-ui';

export default {
  name: 'detail',
  data() {
    return {
      lucky: 0,
      test: [],
      open: [],
      temp:[],
      close: [1, 2, 3, 4],
      value: false,
      closeVal: false,
      openVals: [],
      closeVals: []
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      let str = this.getId();
      let self = this;
      this.Api.timerTask(str, function (msg) {
        let results = msg.data;
        self.splitData(results)
      })
    },
    getId() {
      return this.$route.params.id;
    },
    delTimer(id) {
      let self = this;
      let data = {
        'id': id
      }
      this.Api.delTimerTask(data, (msg) => {
        if (msg.code == 200) {
          Toast('删除成功');
          self.getList();
        }
      })
    },
    splitData(data) {
      let openArr = [], closeArr = [],tempArr = [];
      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        let date = item.daysOfWeek.split(',');
        let time = item.time;
        let arr = [];

        for (let t = 0; t < date.length; t++) {

          if (date[t] == 1) {
            arr.push('周一');
          }
          if (date[t] == 2) {
            arr.push('周二');
          }
          if (date[t] == 3) {
            arr.push('周三');
          }
          if (date[t] == 4) {
            arr.push('周四');
          }
          if (date[t] == 5) {
            arr.push('周五');
          }
          if (date[t] == 6) {
            arr.push('周六');
          }
          if (date[t] == 7) {
            arr.push('周日');
          }
        }
        let str = arr.join(' ');
        item.date = str;
        item.time = time;
        if (data[i].type === 1) {
          openArr.push(item)
        } else if(data[i].type === 2) {
          closeArr.push(item)
        }else {
          tempArr.push(item)
        }
      }

      this.open = openArr;
      this.close = closeArr;
      this.temp = tempArr;
    },

    changelucky(i) {
      this.lucky = i;
    },
    changOpenVal(id, index, isOPen) {
      let flag = 0;
      if (isOPen === 0) {
        flag = 1;
      }
      this.updateTimerTask(id, flag);
    },
    updateTimerTask(id, isOPen) {
      let self = this;
      let data ={
        'id':id,
        'isOpen':isOPen
      }
      this.Api.updateTimerTask(data, function (msg) {
        if (msg.code == 200) {
          self.getList();
        }
      })
    },
    turn(checked) {
      let arr = [];
      let opens = this.openVals;
      for (var i = 0; i < opens.length; i++) {
        arr.push(this.value)
      }
      this.openVals = arr;

    },
    turnClose() {
      let arr = [];
      let closes = this.closeVals;
      for (var i = 0; i < closes.length; i++) {
        arr.push(this.closeVal)
      }
      this.closeVals = arr;
    },

    goBack() {
      this.$router.push({path: '/equipment/detail/' + this.getId()})
    }

  }

}
</script>

<style scoped>
@import url('../../../assets/list.css');
@import url('./style/timer.css');
/* 头部设置 */
.head {
  background-color: #fff;
  border-bottom: 1px solid #DCDCDC;
  height: 44px;
  position: fixed;
  width: 100%;
  z-index: 5;
  line-height: 44px;
  color: #323232;
  letter-spacing: 0.86px;
  text-align: center;
}

.headImg {
  position: absolute;
  left: 15px;
  top: 10px;
  width: 22px;
  height: 22px;

}
.headTitle {
  font-size: 16px;
  height: 44px;
  display: inline-block;
}

.dPo {
  height: 44px;
}

.timerBox {
  position: relative;
}

.luckyLine {
  position: relative;
  background-color: #FFFFFF;
  padding: 5px;
  margin: 15px 0;
  border-radius: 10px;
  box-shadow: 0 0 5px #aaa;
}

.addTimer {
  position: absolute;
  background: #3C7CFF;
  color: #fff;
  right: 15px;
  padding: 5px 10px;
  margin: 3px 0px;
  border-radius: 2px;

}

.timer .time {
  margin-top: -10px;
}
</style>




// WEBPACK FOOTER //
// src/components/equipment/timer/timer.vue